import DataVariable from './DataVariable';

export default class StyleDataVariable extends DataVariable {
  defaults() {
    return {
      ...super.defaults(),
    };
  }
}
